

// // import axios from "axios";

// // const ENGINEERING_BASE_URL = "https://backend.maamaas.com/engineering/api";
// // const FOOD_BASE_URL = "https://backend.maamaas.com/food/api/vendors";

// // // ✅ POST API (Engineering Service)
// // export const registerVendor = async (vendorId, payload) => {
// //     try {
// //         const isFormData = payload instanceof FormData;

// //         const response = await axios.post(
// //             `${ENGINEERING_BASE_URL}/vendor/vendor-registration/${vendorId}`,
// //             payload,
// //             {
// //                 headers: isFormData
// //                     ? {
// //                         "Content-Type": "multipart/form-data"
// //                     }
// //                     : {
// //                         "Content-Type": "application/json"
// //                     }
// //             }
// //         );

// //         return response.data;
// //     } catch (error) {
// //         console.error("API Error:", error);
// //         throw error;
// //     }
// // };

// // // ✅ GET API (Engineering Service) - UPDATED ENDPOINT
// // export const getEngineeringVendorById = async (vendorId) => {
// //     try {
// //         const token = localStorage.getItem("authToken");

// //         const response = await axios.get(
// //             `${ENGINEERING_BASE_URL}/get/vendor-registration/${vendorId}`,
// //             {
// //                 headers: {
// //                     "Authorization": `Bearer ${token}`,
// //                     "Content-Type": "application/json"
// //                 }
// //             }
// //         );

// //         return response.data;
// //     } catch (error) {
// //         console.error("GET Engineering Vendor Error:", error);
// //         throw error;
// //     }
// // };

// // // ✅ POST API (Food Service)
// // export const registerVendors = async (vendorId, payload) => {
// //     try {
// //         const isFormData = payload instanceof FormData;

// //         const response = await axios.post(
// //             `${FOOD_BASE_URL}/${vendorId}`,
// //             payload,
// //             {
// //                 headers: isFormData
// //                     ? {
// //                         "Content-Type": "multipart/form-data"
// //                     }
// //                     : {
// //                         "Content-Type": "application/json"
// //                     }
// //             }
// //         );

// //         return response.data;
// //     } catch (error) {
// //         console.error("API Error:", error);
// //         throw error;
// //     }
// // };

// // // ✅ GET API (Food Service)
// // export const getVendorById = async (vendorId) => {
// //     try {
// //         const token = localStorage.getItem("authToken");

// //         const response = await axios.get(
// //             `${FOOD_BASE_URL}/${vendorId}`,
// //             {
// //                 headers: {
// //                     "Authorization": `Bearer ${token}`,
// //                     "Content-Type": "application/json"
// //                 }
// //             }
// //         );

// //         return response.data;
// //     } catch (error) {
// //         console.error("GET Vendor Error:", error);
// //         throw error;
// //     }
// // };



// import axios from "axios";

// const ENGINEERING_BASE_URL = "https://backend.maamaas.com/engineering/api";
// const FOOD_BASE_URL = "https://backend.maamaas.com/food/api/vendors";

// // ✅ POST API (Engineering Service)
// export const registerVendor = async (vendorId, payload) => {
//     try {
//         const isFormData = payload instanceof FormData;

//         const response = await axios.post(
//             `${ENGINEERING_BASE_URL}/vendor/vendor-registration/${vendorId}`,
//             payload,
//             {
//                 headers: isFormData
//                     ? { "Content-Type": "multipart/form-data" }
//                     : { "Content-Type": "application/json" }
//             }
//         );

//         return response.data;
//     } catch (error) {
//         console.error("API Error:", error);
//         throw error;
//     }
// };

// // ✅ UPDATE API (PUT - Engineering Service)
// export const updateEngineeringVendor = async (vendorId, payload) => {
//     try {
//         const isFormData = payload instanceof FormData;

//         const response = await axios.put(
//             `${ENGINEERING_BASE_URL}/vendor-registration/update/${vendorId}`,
//             payload,
//             {
//                 headers: isFormData
//                     ? { "Content-Type": "multipart/form-data" }
//                     : { "Content-Type": "application/json" }
//             }
//         );

//         return response.data;
//     } catch (error) {
//         console.error("PUT API Error:", error);
//         throw error;
//     }
// };

// // ✅ GET API (Engineering Service)
// export const getEngineeringVendorById = async (vendorId) => {
//     try {
//         const token = localStorage.getItem("authToken");

//         const response = await axios.get(
//             `${ENGINEERING_BASE_URL}/get/vendor-registration/${vendorId}`,
//             {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             }
//         );

//         return response.data;
//     } catch (error) {
//         console.error("GET Engineering Vendor Error:", error);
//         throw error;
//     }
// };

// // ✅ POST API (Food Service)
// export const registerVendors = async (vendorId, payload) => {
//     try {
//         const isFormData = payload instanceof FormData;

//         const response = await axios.post(
//             `${FOOD_BASE_URL}/${vendorId}`,
//             payload,
//             {
//                 headers: isFormData
//                     ? { "Content-Type": "multipart/form-data" }
//                     : { "Content-Type": "application/json" }
//             }
//         );

//         return response.data;
//     } catch (error) {
//         console.error("API Error:", error);
//         throw error;
//     }
// };

// // ✅ GET API (Food Service)
// export const getVendorById = async (vendorId) => {
//     try {
//         const token = localStorage.getItem("authToken");

//         const response = await axios.get(
//             `${FOOD_BASE_URL}/${vendorId}`,
//             {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             }
//         );

//         return response.data;
//     } catch (error) {
//         console.error("GET Vendor Error:", error);
//         throw error;
//     }
// };



import axios from "axios";

const ENGINEERING_BASE_URL = "https://backend.maamaas.com/engineering/api";
const FOOD_BASE_URL = "https://backend.maamaas.com/food/api/vendors";

// ==================== ENGINEERING APIs ====================

// ✅ POST API (Engineering Service)
export const registerVendor = async (vendorId, payload) => {
    try {
        const isFormData = payload instanceof FormData;

        const response = await axios.post(
            `${ENGINEERING_BASE_URL}/vendor/vendor-registration/${vendorId}`,
            payload,
            {
                headers: isFormData
                    ? { "Content-Type": "multipart/form-data" }
                    : { "Content-Type": "application/json" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};

// ✅ UPDATE API (PUT - Engineering Service)
export const updateEngineeringVendor = async (vendorId, payload) => {
    try {
        const isFormData = payload instanceof FormData;

        const response = await axios.put(
            `${ENGINEERING_BASE_URL}/vendor-registration/update/${vendorId}`,
            payload,
            {
                headers: isFormData
                    ? { "Content-Type": "multipart/form-data" }
                    : { "Content-Type": "application/json" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("PUT API Error:", error);
        throw error;
    }
};

// ✅ GET API (Engineering Service)
export const getEngineeringVendorById = async (vendorId) => {
    try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
            `${ENGINEERING_BASE_URL}/get/vendor-registration/${vendorId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("GET Engineering Vendor Error:", error);
        throw error;
    }
};

// ==================== FOOD APIs ====================

// ✅ POST API (Food Service) - CREATE
export const registerVendors = async (vendorId, payload) => {
    try {
        const isFormData = payload instanceof FormData;

        const response = await axios.post(
            `${FOOD_BASE_URL}/${vendorId}`,
            payload,
            {
                headers: isFormData
                    ? { "Content-Type": "multipart/form-data" }
                    : { "Content-Type": "application/json" }
            }
        );

        return response.data;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};

// ✅ UPDATE API (PUT - Food Service) - EXACTLY like Postman
// ✅ UPDATE API (PUT - Food Service) - MUST use FormData
export const updateFoodVendor = async (vendorId, payload) => {
    try {
        const token = localStorage.getItem("authToken");
        //console.log("🔍 [PUT] Updating vendor with ID:", vendorId);
        //console.log("🔍 [PUT] Token exists:", !!token);
        //console.log("🔍 [PUT] Payload type:", payload instanceof FormData ? "FormData" : typeof payload);

        // For debugging - log FormData contents
        if (payload instanceof FormData) {
            for (let pair of payload.entries()) {
                //console.log("🔍 [PUT] FormData entry:", pair[0], pair[1]);
            }
        }

        // ✅ IMPORTANT: Do NOT set Content-Type header - let browser set it with boundary
        const response = await axios.put(
            `${FOOD_BASE_URL}/edit/${vendorId}`,
            payload,
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                    // ❌ DO NOT set Content-Type here - browser will add multipart/form-data with boundary
                }
            }
        );

        //console.log("✅ [PUT] Update successful:", response.data);
        return response.data;
    } catch (error) {
        console.error("PUT Food API Error:", error);
        console.error("PUT Error Response Data:", error.response?.data);
        console.error("PUT Error Status:", error.response?.status);
        throw error;
    }
};
// ✅ GET API (Food Service)
export const getVendorById = async (vendorId) => {
    try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
            `${FOOD_BASE_URL}/${vendorId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error("GET Vendor Error:", error);
        throw error;
    }
};